/*
 * Jira Ticket:
 * Created Date: Mon, 1st Jun 2020, 16:23:05 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import list from './list';
import create from './create';
import edit from './edit';
import icon from '@material-ui/icons/EventNote';

export default {
  list,
  create,
  edit,
  icon,
};
